import { Discount as DiscountIcon } from '@mafc/icon';
import { DrawerTitle, PromoIconWrapper } from './PromoCodeDrawer.style';
import { useTranslation } from 'react-i18next';
import { AppliedVoucher } from 'network/response/ICart';

const PromoCodeHeader: React.FC<{
  appliedPromo: AppliedVoucher | null;
}> = ({ appliedPromo }) => {
  const { t } = useTranslation();

  return (
    <DrawerTitle>
      {appliedPromo ? (
        t('promo.voucherApplied', {
          promoCode: appliedPromo.voucherCode,
        })
      ) : (
        <>
          <PromoIconWrapper display={[null, null, 'none']}>
            <DiscountIcon height="24" width="24" size="CUSTOm" />
          </PromoIconWrapper>
          {t('promo.enterVoucherCode')}
        </>
      )}
    </DrawerTitle>
  );
};

export default PromoCodeHeader;
